export { selectUnit } from './diff';
export { defaultNumberOption, getInternalSlot, getMultiInternalSlots, getNumberOption, getOption, isLiteralPart, partitionPattern, setInternalSlot, setMultiInternalSlots, setNumberFormatDigitOptions, toObject, objectIs, isWellFormedCurrencyCode, toString, formatNumericToString, toRawFixed, toRawPrecision, getMagnitude, repeat, hasOwnProperty, isWellFormedUnitIdentifier, defineProperty, } from './polyfill-utils';
export { createResolveLocale, getLocaleHierarchy, supportedLocales, unpackData, isMissingLocaleDataError, } from './resolve-locale';
export * from './units';
export { removeUnitNamespace } from './units';
export { invariant } from './invariant';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/node_modules/@formatjs/intl-utils/lib/index.js
// module id = 520
// module chunks = 1